<script lang="ts">
  import { cn } from '@shared/utils';

  export let isOpen = false;
</script>

<div
  class="grid transition-[grid-template-rows] duration-500 ease-in-out {isOpen ? 'grid-rows-1' : `grid-rows-hidden`}"
>
  <div
    class="{cn('overflow-hidden opacity-0 transition-opacity duration-1000', {
      'opacity-100': isOpen,
    })}"
  >
    <slot />
  </div>
</div>
